export const environment = {
  production: true,
  basePath: 'https://API.test.kanu-klub.de',
};
